<template>
  <thead>
    <tr class="flex flex-row items-center gap-2">
      <th
        scope="col"
        class="uppercase text-left font-normal text-platform-text-2 w-28 md:w-[86px] xl:w-28"
      >
        {{ $t("product.bidder") }}
      </th>
      <th
        scope="col"
        class="uppercase flex font-normal text-platform-text-2 w-28"
      >
        {{ $t("product.date") }}
      </th>
      <th
        scope="col"
        class="uppercase font-normal text-platform-text-2 ml-auto text-right"
      >
        {{ $t("product.bid") }}
      </th>
    </tr>
  </thead>
</template>
